import { jsx as _jsx } from "react/jsx-runtime";
import { alpha, IconButton, useMediaQuery, useTheme } from "@mui/material";
export const EIconButton = ({ children, fixedHeight = false, onClick, height = "48px", disabled, }) => {
    const theme = useTheme();
    const isMd = useMediaQuery(theme.breakpoints.down("lg"));
    return (_jsx(IconButton, { disabled: disabled, size: isMd ? "small" : "large", sx: {
            color: theme.palette.edark.main,
            borderRadius: "8px",
            border: `1px solid ${alpha(theme.palette.edark.main, 0.6)}`,
        }, style: {
            height: fixedHeight ? height : "auto",
            width: fixedHeight ? 48 : "auto",
        }, onClick: onClick, children: children }));
};
